module.exports = __webpack_public_path__ + "static/media/full_gear_front.88580e98.jpg";